import React from "react";

// MUI Imports
import TableBody from "@mui/material/TableBody";

// Component Imports
import TeaserResultRow from "./TeaserResultRow";

const TeaserResultTableBody = ({
  brandId,
  teaserData
}) => {
  return (
    <TableBody className="table-background-color">
      {teaserData?.map((teaserResult, idx) => (
        <TeaserResultRow
          key={idx}
          idx={idx}
          brand={brandId}
          row={teaserResult}
        />
      ))}
    </TableBody>
  );
};

export default TeaserResultTableBody;
